import axiosRequest from 'axios'

import { SCHEDULER_API_URL } from '@/constants'

export const schedulerInstance = axiosRequest.create({
  baseURL: `${SCHEDULER_API_URL}api`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})
